import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/puesto/puestoSelectors';
import DrawerButton from 'src/view/shared/view/DrawerButton';
import PuestoView from '../view/PuestoView';

function PuestoListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerPuestoViewPage'}
          type={props.type || 'chip'}
          entity={'puesto'}
          tooltipTitle={i18n(record.nombre)}
          buttonTitle={i18n(record.nombre)}
          width={window.innerWidth * 0.55}
          record={record}
          contractorsView={props.contractorsView}
          component={<PuestoView record={record} drawer={true} contractorsView={props.contractorsView} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

PuestoListItem.propTypes = {
  value: PropTypes.any,
  type: PropTypes.string,
};

export default PuestoListItem;
